import React, { Component } from "react";


const MyMessage = () =>{

    return(

        <div>This is My Message sreen</div>

    )
}


export default MyMessage;


// WEBPACK FOOTER //
// ./src/Pages/MyMessage.js